import React from "react"
import _ from "lodash"
import { Link } from "gatsby"
import styles from "../../styles/global.module.scss"
import { FaWrench } from "react-icons/fa"
import convertServicesSlug from "../../helpers/convertServicesSlug"
import { useGetServiceCategories } from "../../hooks/useGetServiceCategories"

const ServiceItemBox = props => {
  const { service } = props

  // Get all service categories
  let service_cats = useGetServiceCategories()

  let active_slug = convertServicesSlug(
    service_cats,
    service,
    service.fields.slug
  )

  return (
    <div className={styles.serviceItem}>
      <div className={styles.serviceItemContent}>
        <div className={styles.serviceIcon}>
          <FaWrench />
        </div>
        <h2>
          <Link to={`${active_slug}/`}>{service.frontmatter.name}</Link>
        </h2>
        <div
          className={`${styles.buttonContain} ${styles.flexWrapper} ${styles.serviceBtns}`}
        >
          <Link className={styles.btn} to={`${active_slug}/`}>
            View Service
          </Link>
          <Link
            className={styles.btn}
            to={`/request-a-quote/`}
            state={{
              service: service.frontmatter.name,
            }}
          >
            Request Quote
          </Link>
        </div>
      </div>
    </div>
  )
}

export default function ServiceItems(props) {
  const { services } = props
  return (
    <div id={styles.servicesList} className={styles.flexWrapper}>
      {services.map((item, i) => {
        const service = item.node
        return <ServiceItemBox service={service} key={i} />
      })}
    </div>
  )
}
